import { CompanyStore } from 'types';

import { initState } from './initState';
import { actions } from './actions';
import { thunks } from './thunks';

export const company: CompanyStore = {
  ...initState,
  ...actions,
  ...thunks,
};
